import React, { useRef } from 'react';

const HorizontalNavbar = ({ renderSelections }) => {
  const scrollRef = useRef<HTMLUListElement | null>(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft -= 200;
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += 200;
    }
  };

  return (
    <div
      id="horizontalnavbar-wrapper"
      data-testid="horizontalnavbar-wrapper"
      className="flex flex-row"
    >
      <button
        id="horizontalnavbar-button-scrollleft"
        data-testid="horizontalnavbar-button-scrollleft"
        className="bg-gray-300 px-2 border-0 hover:bg-gray-500/80"
        onClick={scrollLeft}
      >
        {'<'}
      </button>
      <ul
        id="horizontalnavbar-scroll-content"
        data-testid="horizontalnavbar-scroll-content"
        className="flex flex-row overflow-hidden !list-none w-full m-0 p-0"
        style={{ borderBottom: '1px solid #dddddd' }}
        ref={scrollRef}
      >
        {renderSelections()}
      </ul>
      <button
        id="horizontalnavbar-button-scrollright"
        data-testid="horizontalnavbar-button-scrollright"
        className="bg-gray-300 px-2 border-0 hover:bg-gray-500/80"
        onClick={scrollRight}
      >
        {'>'}
      </button>
    </div>
  );
};

export default HorizontalNavbar;
